import { useI18n } from "../../../i18n/I18nContext";

import Style from "./Services.module.css";

const CompanyDescription = () => {
  const { copy } = useI18n();
  const servicesCopy = copy.home.services;

  return (
    <div className={Style["company-description"]}>
      <h2>{servicesCopy.title}</h2>
      {servicesCopy.paragraphs.map((paragraph) => (
        <p key={paragraph}>{paragraph}</p>
      ))}
    </div>
  );
};

export default CompanyDescription;
